import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const lynxTableStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            background: theme.colors.neutrals.white,
            marginTop: "15px",
        },

        indicator: {
            height: 100,
            display: "flex",
            justifyContent: "flex",
        },

        tableBody: {
            position: "relative",
        },

        indicatorContainer: {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            background: "white",
            minHeight: "200px",
            zIndex: 1,
            padding: "30px",
            display: "flex",
            justifyContent: "center",
        },
    })
);
